export default Object.freeze({
  CHAT: 'chat',
  ROOM: 'auth'
})
